<template>
  <Table :columns="columns" :data="dataSource" :loading="loading"></Table>
</template>
<script>
export default {
  name: "configTable",
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    childColumns: {
      type: Array,
      default: () => []
    },
    businessColumns: {
      type: Array,
      default: () => []
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
}
</script>